import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import { withTranslation } from 'react-i18next'

class FilterBar extends Component {
  // tine un boton de mostrar / ocultar filtros
  // contine el filtro de "search"

  static defaultProps = {
    value: '',
    onchange: () => null,
  }

  state = {
    isOpen: this.props.defaultOpen || false,
  }

  render() {
    //TODO:el placeholder del input no reconoce la traducción, pensar ....
    const { isOpen } = this.state
    const { t } = this.props
    return (
      <div style={this.props.style} className={this.props.className}>
        <div className="filter-bar">
          <div className="search-filter">
            <input
              value={this.props.search}
              onChange={(e) => this.props.onChange(e.target.value, 'searchFilter')}
              type="input"
              className="input-search"
              placeholder={t('Buscar')}
            />
            <div className="icon-input-search" />
          </div>
          <button
            className={`advanced-filters ${isOpen ? 'show-advanced-filters' : 'hide-advanced-filters'}`}
            onClick={() => this.setState({ isOpen: !isOpen })}
          >
            {!isOpen ? <Trans>Mas filtros</Trans> : <Trans>Cerrar</Trans>}
          </button>
        </div>

        {isOpen && (
          <div className="container-filters-extended">
            <div className="filter-extended">
              {this.props.children}
              <div className="container-apply-filters">
                <button
                  type="button"
                  className="apply-filters"
                  onClick={() => this.props.onChange(this.props.value, 'applyFilters')}
                >
                  <Trans>Aplicar filtros</Trans>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(FilterBar)
